<template>
  <div class="box6">
    <div class="blockone" ref="block"></div>
    <pageTitle
      title="聚焦培养短视频运营+电商直播运营+<br/>新媒体运营+带货主播"
      text="定位清晰，内容深入，紧跟市场，全新升级至V13.0版"
      titleColor="#1A0400"
      titColor="#665552"
    />
    <div class="subTitle"></div>
    <div class="content">
      <div
        class="subject-box"
        ref="item"
        v-for="(item, index) in list"
        :key="index"
      >
        <div class="subject" @click="changeCur(index)">
          <div class="stage">{{ item.stage }}</div>
          <div class="title">{{ item.nav }}</div>
          <div
            class="icon"
            :class="{ 'img-rotate': cur == index && showAnswer }"
          >
            <img src="../../../assets/coursePage/ai/box6/icon-down.png" alt />
          </div>
        </div>

        <div
          class="course-content"
          :class="{ 'show-answer': cur == index && showAnswer }"
        >
          <div class="line"></div>

          <div class="title-icon">主讲内容</div>

          <div class="targe">
            <p v-for="j in item.text" :key="j + 'a'" v-html="j"></p>
          </div>

          <div class="title-icon">涉及工具</div>

          <div class="targe">
            <div class="item" v-for="i in item.tool" :key="i.name + 'b'">
              <img
                v-if="i.imgName"
                ref="img"
                :src="
                  require(`../../../assets/coursePage/newMedia/box6/tool/${i.imgName}.png`)
                "
                alt=""
              />
              <h4 ref="text" v-if="i.imgName">{{ i.name }}</h4>
            </div>
          </div>

          <div class="title-icon special">能力提升</div>
          <div class="skillImg">
            <img
              :src="
                require(`../../../assets/coursePage/newMedia/box6/stageSection0${
                  index + 1
                }.png`)
              "
              alt=""
            />
          </div>
        </div>
      </div>
    </div>

    <div class="btn" @click="openDetail">了解更多课程详情</div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import check from "../../../utils/check";
export default {
  components: {
    pageTitle,
  },
  data() {
    return {
      list: [
        {
          nav: "短视频拍剪基础",
          stage: "阶段一",
          tool: [
            {
              name:'剪映',
              imgName:'jianying'
            },{
              name:'PS',
              imgName:'Photoshop'
            },{
              name:'轻抖',
              imgName:'lightdou'
            },{
              name:'开拍',
              imgName:'kaipai'
            },{
              name:'图怪兽',
              imgName:'tumonster'
            },{
              name:'可画',
              imgName:'canva'
            },{
              name:'小熊录屏',
              imgName:'xiaoxiong'
            },{
              name:'抖音',
              imgName:'douyin'
            },{
              name:'快手',
              imgName:'kuaishou'
            },{
              name:'EV录屏',
              imgName:'ev'
            },{
              name:'迅雷',
              imgName:'xunlei'
            },{
              name:'格式工厂',
              imgName:'geshihua'
            },
            {
              name:'达多多',
              imgName:'dadouduo'
            },
          ],
          text: [
            "第1章 什么是短视频运营",
            "第2章 新媒体运营必备图像处理技巧",
            "第3章 短视频发展前景",
            "第4章 剪映剪辑基础",
            "第5章 影视剪辑账号制作流程",
            "第6章 口播账号拍摄制作流程",
            "第7章 Vlog账号拍摄制作流程"
          ],

          boxImg: "stageSection01",
        },
        {
          nav: "AI+短视频制作",
          stage: "阶段二",
          tool: [{
            name: '剪映',
            imgName: 'jianying'
          }, {
            name: '轻抖',
            imgName: 'lightdou'
          }, {
            name: '开拍',
            imgName: 'kaipai'
          }, {
            name: '抖音',
            imgName: 'douyin'
          }, {
            name: '小红书',
            imgName: 'hongshu'
          }, {
            name: '视频号',
            imgName: 'shipinzhibo'
          }],

          text: [
            "第1章 短视频制作-拉片和分镜设计",
            "第2章 短视频制作-景别和运镜",
            "第3章 短视频制作-灯光和机位图",
            "第4章 短视频制作-镜头语言构图",
            "第5章 短视频制作-拍摄设备",
            "第6章 短视频制作-专业剪辑技巧",
            "第7章 短视频制作-抖音主流视频剪辑"
          ],

          boxImg: "stageSection02",
        },
        {
          nav: "AI+短视频运营",
          stage: "阶段三",
          tool: [
            {
              name: "Premiere",
              imgName: "Premiere",
            },
            {
              name: "After Effects",
              imgName: "ae",
            },
            {
              name: "有米有数",
              imgName: "youmeiyou",
            },
            {
              name: "蝉妈妈",
              imgName: "mama",
            },
            {
              name: "剪映APP",
              imgName: "jianying",
            },
            {
              name: "格式工厂",
              imgName: "geshihua",
            },
            {
              name: "巨量星图",
              imgName: "xingtu",
            },
            {
              name: "巨量千川",
              imgName: "qianchuan",
            },
            {
              name: "抖店",
              imgName: "doudian",
            },
            {
              name: "Dou+",
              imgName: "dou",
            },
            {
              name: "视频号",
              imgName: "shipinzhibo",
            },
            {
              name: "飞瓜数据",
              imgName: "feigua",
            },
            {
              name: "小红书",
              imgName: "hongshu",
            },
            {
              name: "巨量算数",
              imgName: "suanshu",
            },
            {
              name: "巨量创意",
              imgName: "juliang",
            },
            {
              name: "快手",
              imgName: "kuaishou",
            },
            {
              name: "快手直播伴侣",
              imgName: "zhibo",
            },
            {
              name: "视频号小店",
              imgName: "xiaohao",
            },
            {
              name: "快手直播伴侣1",
            },
            {
              name: "视频号小店1",
            },
          ],

          text: [
            "第1章 短视频运营 - 定位搭建",
            "第2章 短视频运营 - 内容选题",
            "第3章 短视频运营 - 内容运营",
            "第4章 短视频运营 - 数据运营",
            "第5章 短视频运营 - 蓝 V 企业账号",
            "第6章 短视频运营 - dou + 投放",
            "第7章 短视频运营 - 小红书运营",
            "第8章 附件短视频 IP 运营方案（健身达人）",
            "第9章 短视频运营 - 7 步快速起号法"
          ],

          boxImg: "stageSection03",
        },
        {
          nav: "AI+直播电商运营",
          stage: "阶段四",
          tool: [
            {
              name: "OBS studio",
              imgName: "OBSstudio",
            },
            {
              name: "哔哩哔哩",
              imgName: "bilibili",
            },
            {
              name: "抖音直播伴侣",
              imgName: "douyin",
            },
            {
              name: "视频直播号",
              imgName: "shipinzhibo",
            },
            {
              name: "义乌购",
              imgName: "yiwu",
            },
            {
              name: "阿里巴巴",
              imgName: "alibb",
            },
            {
              name: "巨量千川",
              imgName: "qianchuan",
            },
            {
              name: "小店随心推",
              imgName: "suixintui",
            },
            {
              name: "抖音橱窗",
              imgName: "gouwuche",
            },
            {
              name: "抖音橱",
            },
          ],

          text: [
            "第1章 直播基础 - 认知篇",
            "第2章 直播电商人 - 主播话术",
            "第3章 直播电商货 - 选品定价",
            "第4章 直播电商货 - 抖音小店",
            "第5章 直播电商货 - 货品营销",
            "第6章 直播电商场 - 场景搭建",
            "第7章 直播电商场 - 直播推流",
            "第8章 直播电商 - 巨量千川投放",
            "第9章 憋单话术与直播脚本",
            "第10章 直播电商数据",
            "第11章 视频号直播",
            "第12章 实训安排"
          ],

          boxImg: "stageSection04",
        },
      ],
      cur: -1,
      showAnswer: true,
      prevItemHeight: 0,
    };
  },
  mounted() {
    this.$refs.text.forEach((item) => {
      let moveWidth = (item.clientWidth - this.$refs.img[0].clientWidth) / 2;
      item.style.left = -moveWidth + "px";
    });
  },
  methods: {
    goTop(index) {
      window.scrollTo(
        0,
        this.$refs.item[index].offsetTop -
          this.$refs.block.offsetHeight -
          this.$refs.block.offsetHeight * 0.3 -
          this.prevItemHeight
      );
    },
    openDetail() {
      if (localStorage.getItem(`detail-${check.getUrlParam("nid")}`)) {
        window.location.href = localStorage.getItem(
          `detail-${check.getUrlParam("nid")}`
        );
      } else {
        this.clickZiXun()
      }
       this.mai("新媒体+短视频-就业课","了解更多课程详情",0,null)
    },
    changeCur(index) {
      const a = document.querySelector(".show-answer");
      if (a != null && index > this.cur) {
        this.prevItemHeight = a.offsetHeight;
      }
      if (!this.showAnswer || index <= this.cur) {
        this.prevItemHeight = 0;
      }
      if (index == this.cur) {
        this.showAnswer = !this.showAnswer;
        this.cur = index;
      } else {
        this.showAnswer = true;
        this.cur = index;
      }
      this.goTop(index);
    },
  },
};
</script>

<style lang="less" scoped>
.box6 {
  padding: 0px 0px 88px 0;
  width: 100%;
  background: url("../../../assets/coursePage/newMedia/box6/bgc.png") no-repeat;
  background-size: cover;
  overflow: hidden;
  .blockone {
    height: 80px;
  }
  .subTitle {
    background: url("../../../assets/coursePage/newMedia/box6/subtitle.png");
    width: 728px;
    background-size: cover;
    height: 112px;
    margin: 48px auto 20px;
  }

  .btn {
    margin: 0 auto;
    margin-top: 60px;
    width: 690px;
    height: 96px;
    font-family: PingFangSC-Semibold;
    font-size: 30px;
    line-height: 96px;
    text-align: center;

    text-shadow: 2px 6px 0px #207dff;
    background: linear-gradient(180deg, #ff8932 0%, #ff2a00 100%);
    box-shadow: 0px 10px 20px 0px #ffd4cc, 0px 4px 16px 0px #fecebf;
    border-radius: 48px;
    font-size: 30px;
    font-family: PingFang SC;
    font-weight: 600;
    color: #ffffff;

    text-shadow: 0px 6px 5px rgba(234, 49, 12, 0.77);
  }

  .title-top {
    position: relative;
    margin: 60px auto 0;
    margin-bottom: 40px;
    padding-left: 50px;
    width: 690px;
    height: 100px;
    background: url("../../../assets/coursePage/pythonData/box9/title.png")
      no-repeat;
    background-size: cover;
    border-radius: 20px;
    box-shadow: 0px 6px 29px 0px rgba(135, 212, 240, 0.98);
    box-sizing: border-box;
    font-family: PingFangSC-Medium;
    font-size: 28px;
    font-weight: normal;
    line-height: 100px;
    letter-spacing: 0px;
    color: #ffffff;
    span {
      font-family: PingFangSC-Semibold;
      font-size: 32px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 100px;
      letter-spacing: 0px;
      color: #ffffff;
      text-shadow: 6px 16px 0px #3f6ae4;
    }
    &::after {
      position: absolute;
      right: 0px;
      bottom: 0px;
      content: "";
      width: 180px;
      height: 126px;
      background: url("../../../assets/coursePage/pythonData/box9/icon.png")
        no-repeat;
      background-size: cover;
    }
  }

  .subject-box {
    margin: 0 auto;
    margin-bottom: 16px;
    width: 686px;
    overflow: hidden;
    background-color: #ffffff;
    border-radius: 16px;
    box-shadow: 0px 8px 29px 0px rgba(255, 172, 131, 0.25);
  }
  .subject {
    display: flex;
    align-items: center;
    position: relative;
    padding: 28px 32px;

    width: 100%;
    height: 96px;
    background: #ffffff;
    border-radius: 16px;
    box-sizing: border-box;
    z-index: 5;
    .stage {
      font-family: PingFangSC-Semibold;
      font-size: 28px;
      font-weight: bold;
      line-height: 96px;
      letter-spacing: 0px;
      white-space: nowrap;
      color: rgba(255, 109, 80, 1);
    }

    .title {
      margin-left: 24px;
      margin-right: 20px;
      font-family: PingFangSC-Medium;
      font-size: 28px;
      font-weight: bold;
      font-stretch: normal;

      letter-spacing: 0px;
      color: #3a2c29;
      width: 496px;
    }

    .icon {
      width: 28px;
      height: 28px;
      transition: 0.5s ease all;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .img-rotate {
      transition: 0.5s ease all;
      transform: rotate(180deg);
    }

    font-size: 28px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #4e5969;
  }

  .course-content {
    padding: 0px 32px;
    position: relative;
    width: 100%;
    box-sizing: border-box;
    background: #fff;

    max-height: 0;
    opacity: 0;
    border-radius: 0px 0px 16px 16px;
    transition: 0.3s ease all;

    overflow: hidden;
    z-index: 3;

    .line {
      margin: 0 auto;
      margin-bottom: 32px;
      width: 622px;
      height: 1px;
      background: #f2f3f5;
    }
  }

  .show-answer {
    padding: 0px 32px;
    // padding-bottom: 40px;
    // display: block;
    max-height: 2500px;
    opacity: 1;
    transition: 0.4s ease all;
  }

  .title-icon {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    height: 40px;
    font-size: 28px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    color: #1d2129;

    img {
      margin-right: 16px;
      width: 22px;
      height: 21px;
    }

    .icon1 {
      width: 181px;
      height: 22px;
    }
  }

  .main-content {
    margin-bottom: 20px;
    display: flex;
    flex-wrap: wrap;
    .block {
      margin-bottom: 16px;
      margin-right: 16px;
      padding: 0px 16px;
      height: 44px;
      background: rgba(179, 227, 254, 0.32);
      border-radius: 8px;

      font-size: 22px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 44px;
    }
  }

  .targe {
    margin-bottom: 48px;
    font-family: PingFang SC;
    font-size: 26px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #4e5969;
    line-height: 44px;
    justify-content: space-between;
    p {
      position: relative;
      display: flex;
      align-items: center;
      width: 100%;
    }
    display: flex;
    flex-wrap: wrap;

    align-content: flex-start;
    .item {
      position: relative;
      margin-right: 55px;
      margin-bottom: 56px;
      font-size: 22px;
      width: 74px;
      img {
        width: 74px;
        height: 74px;
      }
      h4 {
        position: absolute;
        width: max-content;

        text-align: center;
      }
    }
    .item:nth-child(5n) {
      margin-right: 0;
    }
    &::after {
      content: '';
      width: 210px;
    }
  }
  .skillImg {
    width: 100%;
    height: 100%;
    object-fit: contain;
    background: #fffbfa;
    border-radius: 14px;
    margin-bottom: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5%;
    box-sizing: border-box;
    img {
      width: 90%;
      height: 90%;
    }
  }
}
</style>
